import { render, staticRenderFns } from "./Step2DetailConfig.vue?vue&type=template&id=a6344b5c&scoped=true&"
import script from "./Step2DetailConfig.vue?vue&type=script&lang=js&"
export * from "./Step2DetailConfig.vue?vue&type=script&lang=js&"
import style0 from "./Step2DetailConfig.vue?vue&type=style&index=0&id=a6344b5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6344b5c",
  null
  
)

export default component.exports